import React, { useState } from "react";
import TripCard from "./views/TripCard";
import { useNavigate, useLocation } from "react-router-dom";
import ROUTE_PATHS from "../../utils/routePaths";
import VersionNotification from "../../components/elements/VersionNotification";
import VersioningComponent from "./views/VersioningComponent";

const ListOfTripRequest = ({ trips, currentPage }) => {
  const navigate = useNavigate();
  const [showVersionModal, setShowVersionModal] = useState(false);

  const handleTripClick = (tripId) => {
    if (!tripId) return;
    navigate(ROUTE_PATHS.TRIP_DETAILS(tripId), {
      state: { currentPage: currentPage, tripId }
    });
  };

  const handleVersionClick = () => {
    setShowVersionModal(true);
  };

  return (
    <div className="main-content">
      <VersionNotification onVersionClick={handleVersionClick} />
      <VersioningComponent 
        isOpen={showVersionModal} 
        onClose={() => setShowVersionModal(false)} 
      />
      <div className="trip-request-list">
        {trips?.map((trip) => {
          const requiresOvertime =
            trip?.requiresArrivalOvertime ||
            trip?.requiresDepartureOvertime ||
            false;

          return (
            <TripCard
              key={trip?.id}
              tripData={trip}
              afterHoursStatus={requiresOvertime}
              onClick={() => handleTripClick(trip?.id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ListOfTripRequest;
